import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useQualificationStructureUrl } from '../routing';
import ViewQualificationStructureComparisonBreadcrumbs from './QualificationStructureComparisonBreadcrumbs';

const ViewQualificationStructureBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { getStructureListUrl } = useQualificationStructureUrl();
  return (
    <ViewQualificationStructureComparisonBreadcrumbs>
      <SingleBreadcrumbItem entity="History" link={getStructureListUrl} />
      {children}
    </ViewQualificationStructureComparisonBreadcrumbs>
  );
};

export default ViewQualificationStructureBreadcrumbs;
